<template>
  <div class="site-legal-content">
    <div class="site-legal-content__wrapper">

      <p class="site-legal-content__wrapper__title"><strong>1. Objet</strong></p>
      <p>Les présentes Conditions Générales d'Utilisation (ci-après « CGU ») ont pour objet de définir les modalités d'accès et d'utilisation du service CRA Freelance, accessible depuis le site cra-freelance.fr (ci-après « le Service »), édité par Litee Solutions (ci-après « l'Éditeur »).</p>
      <p>L'utilisation du Service implique l'acceptation pleine et entière des présentes CGU.</p>

      <p class="site-legal-content__wrapper__title"><strong>2. Description du Service</strong></p>
      <p>CRA Freelance est un outil en ligne permettant aux travailleurs indépendants (freelances) de :</p>
      <ul>
        <li>Créer des Comptes Rendus d'Activité (CRA) mensuels</li>
        <li>Signer électroniquement leurs CRA</li>
        <li>Envoyer leurs CRA pour validation au client final</li>
        <li>Exporter leurs CRA au format PDF</li>
      </ul>
      <p>Une offre Intégration payante propose des fonctionnalités supplémentaires : tableau de bord, notifications de validation, export CSV/Excel, et intégration avec des outils de facturation tiers (Pennylane, Indy, Tiime).</p>

      <p class="site-legal-content__wrapper__title"><strong>3. Accès au Service</strong></p>
      <p>L'accès au Service nécessite la création d'un compte utilisateur avec une adresse email valide. L'utilisateur s'engage à fournir des informations exactes et à jour.</p>
      <p>Le Service est accessible gratuitement dans sa version de base. L'offre Intégration est proposée au tarif indiqué sur la page de tarification du site, susceptible d'évoluer.</p>

      <p class="site-legal-content__wrapper__title"><strong>4. Obligations de l'utilisateur</strong></p>
      <p>L'utilisateur s'engage à :</p>
      <ul>
        <li>Utiliser le Service conformément à sa destination</li>
        <li>Ne pas utiliser le Service à des fins illicites ou contraires aux présentes CGU</li>
        <li>Assurer la confidentialité de ses identifiants de connexion</li>
        <li>Fournir des informations exactes dans ses CRA</li>
        <li>Ne pas tenter de compromettre la sécurité ou le fonctionnement du Service</li>
      </ul>

      <p class="site-legal-content__wrapper__title"><strong>5. Propriété intellectuelle</strong></p>
      <p>L'ensemble des éléments du Service (textes, images, logiciels, base de données, interface) sont protégés par le droit de la propriété intellectuelle et restent la propriété exclusive de l'Éditeur. Toute reproduction, représentation ou exploitation non autorisée est interdite.</p>
      <p>Les CRA et données saisies par l'utilisateur restent sa propriété.</p>

      <p class="site-legal-content__wrapper__title"><strong>6. Données personnelles</strong></p>
      <p>Le traitement des données personnelles est détaillé dans notre <a href="/rgpd">Politique de Confidentialité</a>. En utilisant le Service, l'utilisateur consent au traitement de ses données conformément à cette politique et au RGPD.</p>
      <p>Les données collectées sont : adresse email, nom, prénom, signature électronique, et les données de CRA (jours travaillés, missions, clients).</p>

      <p class="site-legal-content__wrapper__title"><strong>7. Responsabilité</strong></p>
      <p>L'Éditeur met tout en œuvre pour assurer la disponibilité et le bon fonctionnement du Service. Toutefois, il ne saurait être tenu responsable :</p>
      <ul>
        <li>Des interruptions temporaires du Service pour maintenance ou mise à jour</li>
        <li>Des conséquences de l'utilisation des CRA générés (exactitude des informations saisies, validité juridique)</li>
        <li>Des dysfonctionnements liés aux services tiers intégrés (Pennylane, Indy, Tiime)</li>
      </ul>
      <p>L'utilisateur est seul responsable de l'exactitude des informations qu'il saisit dans ses CRA.</p>

      <p class="site-legal-content__wrapper__title"><strong>8. Résiliation</strong></p>
      <p>L'utilisateur peut supprimer son compte à tout moment en contactant l'Éditeur. L'Éditeur se réserve le droit de suspendre ou supprimer un compte en cas de violation des présentes CGU.</p>

      <p class="site-legal-content__wrapper__title"><strong>9. Modification des CGU</strong></p>
      <p>L'Éditeur se réserve le droit de modifier les présentes CGU à tout moment. Les utilisateurs seront informés de toute modification substantielle. La poursuite de l'utilisation du Service après modification vaut acceptation des nouvelles CGU.</p>

      <p class="site-legal-content__wrapper__title"><strong>10. Droit applicable</strong></p>
      <p>Les présentes CGU sont soumises au droit français. Tout litige relatif à l'utilisation du Service sera soumis aux tribunaux compétents de Paris.</p>

      <p style="margin-top: 40px; font-style: italic; color: #666;">Dernière mise à jour : 9 avril 2026</p>
    </div>
  </div>
</template>

<style lang="scss">
  $desktop-breakpoint: 990px;
  $tablet-breakpoint: 672px;

  .site-legal-content {
    ul {
      margin: 10px 0 10px 20px;
      li {
        margin-bottom: 6px;
      }
    }
  }
</style>
